import { IStorage } from "./storage.interface";

class MemoryStorageClass implements IStorage {
    private _keys: string[];
    private _memory: { [key: string]: string; };

    constructor() {
        this._keys = [];
        this._memory = {};
    }
    getAllKeys(): string[] {
        throw new Error("Method not implemented.");
    }
    getAllItems(): any[] {
        throw new Error("Method not implemented.");
    }

    public isSupported(): boolean {
        return true;
        
    }

    public getParsed<T>(key: string): T {
        try {
            return JSON.parse(sessionStorage.getItem(key));
        } catch (ex) {
            return null;
        }
    }

    public get(key: string): any {
        return this._memory.hasOwnProperty(key) ? this._memory[key] : null;
    }

    public set(key: string, value: any): boolean {
        this._memory[key] = value;
        if (this._keys.indexOf(key) < 0) {
            this._keys.push(key);
        }
        return true;
    }

    public delete(key: string): boolean {
        delete this._memory[key];
        const index = this._keys.indexOf(key);
        if (index < 0) return false;
        this._keys.splice(index, 1);
        return true;
    }

    public clear(): boolean {
        // NOTE: no event support
        this._memory = {};
        this._keys = [];
        return true;
    }

    
}


export const MemoryStorage = new MemoryStorageClass();